"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZustandAsyncStorage = void 0;
const async_storage_1 = require("./async_storage");
exports.ZustandAsyncStorage = {
    getItem: function (name) {
        return (0, async_storage_1.load)(name);
    },
    setItem: function (name, value) {
        (0, async_storage_1.save)(name, value);
    },
    removeItem: function (name) {
        (0, async_storage_1.remove)(name);
    }
};
//# sourceMappingURL=zustand_async_storage.js.map